import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser } from '../services/authService';

/**
 * Guards screens that only exist for the platform admin — today, the agency CRM.
 *
 * Deliberately keyed on role, not on holding a master claim: the registry
 * endpoints are {@code @MasterAllowed} and the registry entities are
 * schema-qualified, so the CRM works under a tenant claim too. An admin who is
 * inside an agency can still manage the registry without deselecting first
 * (§1.4.3).
 */
function MasterRoute() {
  return getCurrentUser()?.role === 'INITIAL_ADMIN' ? <Outlet /> : <Navigate to="/" replace />;
}

export default MasterRoute;
